import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  modalTitle: {
    id: 'studio.2vIp92',
    defaultMessage: 'Edit photo',
  },
  scale: {
    id: 'studio.qFTxb3',
    defaultMessage: 'Scale',
  },
  submit: {
    id: 'studio.jvo0vs',
    defaultMessage: 'Save',
  },
});
